import { useEffect } from "react";
import dayjs from "dayjs";
import { ButtonV2, CardRouded, ContainerV2, H1, P, PaginationV2 } from "../../Atoms";
import { FormFilterItineranteV2 } from "../../Molecules/FormFilterItineranteV2";
import { Tracking } from "../../../services/Tracking";
import { useItineranteV2 } from "./useItineranteV2";
import { CardItinerante } from "./Components/CardItinerante";

export const ItineranteV2 = () => {
  const {
    stepIndicator,
    isFiltroAberto,
    handleToggleFiltro,
    handleFiltrar,
    itinerantes,
    pagination,
    setNumberPage,
    submitAgendamento,
  } = useItineranteV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/itinerantes:pageview");
  });

  return (
    <ContainerV2>
      {stepIndicator}
      <div className="pt-8">
        <H1 className="mb-4">Itinerante</H1>
        <P className="mb-10">
          Selecione a sua cidade e a data de sua preferência de acordo com o
          cronograma de itinerantes disponível.
        </P>
      </div>

      {isFiltroAberto ? (
        <CardRouded className="mb-8 p-8">
          <FormFilterItineranteV2 submitForm={handleFiltrar} />
        </CardRouded>
      ) : (
        <div className="mb-6">
          <ButtonV2 variant="outline" onClick={handleToggleFiltro}>
            <img src="/assets/svgs/icon-filter-dark.svg" alt="icone filtro" />
            Filtrar
          </ButtonV2>
        </div>
      )}

      <div className="flex flex-col gap-8">
        {itinerantes.length === 0 ? (
          <P className="text-center">Nenhum itinerante encontrado</P>
        ) : (
          itinerantes.map((itinerante, index) => (
            <CardItinerante
              key={itinerante.uuid}
              striped={index % 2 === 1}
              cidade={itinerante.endereco?.cidade}
              dataRealizacao={dayjs(itinerante.dataRealizacao).format(
                "DD/MM/YYYY",
              )}
              vagas={String(itinerante.quantidadeVagas)}
              onSelect={() => submitAgendamento(itinerante.uuid)}
            />
          ))
        )}
      </div>

      {itinerantes.length > 0 && (
        <PaginationV2
          className="mt-8"
          totalPage={pagination.totalPage}
          totalRegister={pagination.totalRegister}
          actualPage={pagination.actualPage}
          setNumberPage={setNumberPage}
        />
      )}
    </ContainerV2>
  );
};
